
<template>
  <div id="emptyImageWrapper">
    <img id="nothingImage" src="@/assets/images/tap.png"/><br/>
    <p class="emptyText">This action is not implemented yet. Contact you-know-who to include the desired functionality into the next release.</p>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'Unsupported',
  data () {
    return {
      
    }
  },

  methods: {
   
  },
  computed: {
    ...mapState('bot', {
      bot: 'bot',
      project: 'project',
      error: 'error',
      loading: 'loading',
    }),
  },
}
</script>

<style lang="scss" scoped>
  #emptyImageWrapper{
    text-align: center;
    margin-top:30px;
    color:#aaa;
  }
  #nothingImage{
    margin: 0 auto;
    max-width: 50px
  }
  .emptyText{
    margin-top:20px;
  }
</style>
